export enum EYesNoNoneValues {
    NONE = "none",
    NO = "no",
    YES = "yes",
}
